import { render, staticRenderFns } from "./TheFooter copy.vue?vue&type=template&id=844285c4&scoped=true"
import script from "./TheFooter copy.vue?vue&type=script&lang=js"
export * from "./TheFooter copy.vue?vue&type=script&lang=js"
import style0 from "./TheFooter copy.vue?vue&type=style&index=0&id=844285c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844285c4",
  null
  
)

export default component.exports